import { Outlet } from "react-router-dom";

const ProductsParentPage = () => {
    return <Outlet />
}
export default ProductsParentPage;